module.exports = __webpack_public_path__ + "img/microbiome-analysis.6cafe3dd.svg";